import { render } from "./craft.vue?vue&type=template&id=cd75f1aa"
import script from "./craft.vue?vue&type=script&lang=js"
export * from "./craft.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__